export const LOAD = 'PARTNERS:LOAD'
export const REFRESH = 'PARTNERS:REFRESH'
export const CLEAR = 'PARTNERS:CLEAR'
